import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authApi } from '@/lib/api';

/**
 * Hook for reading and changing the UI language.
 *
 * On change: updates i18next (immediate UI re-render), persists to
 * localStorage (picked up by the Axios Accept-Language interceptor),
 * and saves to the backend (so the preference syncs across devices).
 */
export function useLanguage() {
  const { i18n } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate: setLanguage, isPending } = useMutation({
    mutationFn: async (lang: 'nl' | 'en') => {
      await i18n.changeLanguage(lang);
      localStorage.setItem('merkflow_ui_lang', lang);
      await authApi.updateProfile({ uiLanguage: lang });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });

  return {
    currentLang: (i18n.language?.startsWith('nl') ? 'nl' : 'en') as 'nl' | 'en',
    setLanguage,
    isPending,
  };
}
